import { Tabs } from 'antd';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;
export const StyledTabs = styled(Tabs)`
  z-index: 100;
  border-left: 1px solid var(--coolest-gray-20);
  height: 100%;

  .ant-tabs-tab {
    margin: 0;
    padding: var(--spacing-03) var(--spacing-04);
    border-bottom: none;
    margin-bottom: var(--spacing-01);
    min-width: var(--tabs-width);
    height: var(--tabs-height);
  }

  .ant-tabs-tab-active {
    pointer-events: auto;
  }
`;

export const Wrapper = styled.div`
  padding-top: var(--spacing-07);
`;

export const DocumentTabContainer = styled.div<{ $hidePaneContent: boolean }>`
  width: ${({ $hidePaneContent }) =>
    $hidePaneContent ? 'var(--tabs-width)' : ''};
  transition: all 0.3s cubic-bezier(0.29, 0.04, 0.23, 1);

  ${StyledTabs} {
    .ant-tabs-content {
      height: 100%;
    }
    .ant-tabs-content-holder {
      width: 392px;
      border: none;
    }
    .ant-tabs-nav {
      background: var(--white-100);
      border-left: 1px solid var(--coolest-gray-20);
      border-right: 1px solid var(--coolest-gray-20);
    }

    .ant-tabs-tab:hover {
      background-color: var(--coolest-gray-10);
    }
    .ant-tabs-tabpane {
      padding-right: 0;
      padding-left: 0;
    }
  }
`;
